import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import Buttons from "../Controls/Buttons/Button";

const DeleteConfirmationPopup = ({
  open,
  title = "Delete Confirmation",
  message = "Are you sure you want to delete this item? This action cannot be undone.",
  onConfirm,
  onCancel,
  text = "Delete",
  loading = false,
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ minWidth: "500px" }}>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="outlined">
          Cancel
        </Button>
        {/* <Button onClick={onConfirm} color="error" variant="contained">
          {text}
        </Button> */}
        <Buttons
          size="small"
          text={text}
          onClick={onConfirm}
          loading={loading}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationPopup;
